import { createContext } from "react";

import { IAccordionItemContext } from "./accordion-item-context.types";

export default createContext<IAccordionItemContext | undefined>(undefined);
